import { merge } from 'lodash';
import zhJson from './lang/zh.json'; //
import enJson from './lang/en.json';
// 其它组件的国际化
import vhclLocalJson from '@vhcl/locales';

const zhMap = merge({}, zhJson, vhclLocalJson['zh']);
const enMap = merge({}, enJson, vhclLocalJson['en']);

export { zhMap, enMap };
